import { Injectable } from '@angular/core';
import { APIService } from '../shared/service/api.service';

@Injectable({ providedIn: 'root' })
export class FormularioService {

  constructor(private api: APIService) { }

  postForm(form) {
    const formData = new FormData();
    for (const key in form) {
      if (key !== 'reCaptcha') {
        const value = form[key] ? form[key] : '';
        formData.append(`${key}`, value);
      }
    }

    return this.api.postForm(formData);
  }

  getFormFields() {
    return {
      localAlteracao: ['Navegabilidade do site', 'Eixo Tecnológico', 'Curso'],
      camposCurso: [
        { label: 'Perfil profissional de conclusão', field: 'sugestaoPerfilProfissional', checkbox: 'perfProf' },
        { label: 'Carga horária mínima', field: 'sugestaoCargaHoraria', checkbox: 'cargaH' },
        { label: 'Pré-requisitos para ingresso', field: 'sugestaoPreRequisitos', checkbox: 'preRec' },
        { label: 'Legislação profissional', field: 'sugestaoLegislacao', checkbox: 'legisP' },
        { label: 'Itinerários formativos', field: 'sugestaoItinerarios', checkbox: 'itiF' },
        { label: 'Campo de atuação', field: 'sugestaoCampoAtuacao', checkbox: 'campoAt' },
        { label: 'Ocupações CBO associadas', field: 'sugestaoOcupacoesCbo', checkbox: 'ocupCBO' },
        { label: 'Infraestrutura mínima', field: 'sugestaoInfraestruturaMinima', checkbox: 'infMin' },
        { label: 'Outros', field: 'sugestaoOutros', checkbox: 'outros' },
      ],
    };
  }
}
